import React, {useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useToasts} from "react-toast-notifications";

import {sendDischargeSurvey} from "../../../store/actions/admission";
import AdmissionList_Item_Checkbox from "../../AdmissionsList/Item/AdmissionList_Item_Checkbox";
import AdmissionList_Item_Name from "../../CustomLogic/AdmissionList_Item_Name";
import AdmissionList_Item_MoreDrop from "../../AdmissionsList/Item/AdmissionList_Item_MoreDrop";
import {useCustomLogic} from "../../../utils/customLogic";
import AdvancedList_Item_CustomColumn from "../../AdvancedList/AdvancedList_Item_CustomColumn";
import * as constants from "../../../utils/constants";
import * as actionTypes from "../../../store/actions/actionTypes";
import AdmissionList_Item_ManagerCustomUI
    from "../../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Item_ManagerCustomUI";

const DischargeList_Item = ({admission}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {addToast} = useToasts();
    const {keyword} = useParams();
    const auth = useSelector(state => state.auth);
    const state_showDevUI = useSelector(state => state.auth.state_showDevUI);
    const {groupId} = useSelector(state => state.admissionList);
    const {isCustomLogicMaryvale, isCustomLogicHealtheCare, isCustomLogicLifehouse, isCustomLogicESPH, isCustomLogicDemo} = useCustomLogic();
    const reloadingProgress = useSelector(state => state.main.reloadingProgress);
    const [sendingSurvey, setSendingSurvey] = useState(false);

    // Dev-only discharge survey feature: requires the hospital flag AND the dev UI toggle.
    const showSurveyDevUI = auth.selectedHospital.manager_dischargeList_survey && state_showDevUI;

    const sendSurvey = () => {
        if (sendingSurvey) {
            return;
        }
        setSendingSurvey(true);
        dispatch(sendDischargeSurvey(admission, addToast))
            .catch(() => {})
            .finally(() => setSendingSurvey(false));
    }

    // Map the backend AdmissionDocument status const to a human-readable survey state.
    const renderSurveyStatus = () => {
        switch (admission.survey_status) {
            case 'STATUS_COMPLETED':
            case 'STATUS_COMPLETED_OUTSIDE':
                return <span className="badge badge-success">Signed</span>;
            case 'STATUS_VIEWED':
                return <span className="badge badge-warning">Viewed</span>;
            case 'STATUS_NEW':
            case 'STATUS_NEXT':
                return <span className="badge badge-info">Sent</span>;
            case 'STATUS_CUTOFF':
                return <span className="badge badge-danger">Cutoff</span>;
            case null:
            case undefined:
                return <span className="badge badge-secondary">Not sent</span>;
            default:
                return <span className="badge badge-secondary">{admission.survey_status}</span>;
        }
    }

    const goToAdmission = (event) => {
        console.log('[AdmissionList_Item] goToAdmission()')
        if (event.ctrlKey) {
            window.open(`${process.env.REACT_APP_AUTH0_REDIRECT}admission/${admission.id}`, '_blank');
        } else {
            navigate(`/admission/${admission.id}`);
        }
    }

    const renderTime = () => {
        return <>{admission.discharge_date} {admission.discharge_time}</>
    }


    const showCommentsModal = () => dispatch({type: actionTypes.MODAL_COMMENTS_SHOW, admission: admission, commentsType: constants.TYPE_DISCHARGE_COMMENTS});

    const renderManagerDischargeListComments = () => {
        if (admission.discharge_comments_count) {
            switch (admission.discharge_comments_status) {
                case constants.COMMENTS_STATUS.STATUS_PENDING:
                    return (
                        <button type="button" className="btn btn-sm btn-secondary lifehouse-button-orange" onClick={showCommentsModal}>{admission.discharge_comments_count}</button>
                    );
                case constants.COMMENTS_STATUS.STATUS_CLOSED:
                    return (
                        <button type="button" className="btn btn-sm btn-secondary lifehouse-button-green" onClick={showCommentsModal}>{admission.discharge_comments_count}</button>
                    )
            }
        }
        return <button type="button" className="btn btn-sm btn-secondary" onClick={showCommentsModal}>-</button>;
    }

    return (
        <tr>
            <td className="pointer"><AdmissionList_Item_Checkbox admission={admission}/></td>
            <AdmissionList_Item_ManagerCustomUI admission={admission} position={1} location="LOCATION_TYPE_DISCHARGE_LIST"/>
            <td onClick={goToAdmission} style={{cursor: 'pointer', width: '50%'}}>
                <AdmissionList_Item_Name admission={admission}/>
            </td>
            <AdmissionList_Item_ManagerCustomUI admission={admission} position={2} location="LOCATION_TYPE_DISCHARGE_LIST"/>
            {(isCustomLogicMaryvale() || isCustomLogicHealtheCare() || isCustomLogicESPH() || isCustomLogicDemo()) &&
                <td onClick={goToAdmission} className="pointer">{admission.admittingDoctor}</td>}
            <AdmissionList_Item_ManagerCustomUI admission={admission} position={3} location="LOCATION_TYPE_DISCHARGE_LIST"/>
            <td onClick={goToAdmission} className="pointer">{renderTime()}</td>
            <AdmissionList_Item_ManagerCustomUI admission={admission} position={4} location="LOCATION_TYPE_DISCHARGE_LIST"/>
            {/*{renderManagerCustomUI()}*/}
            {auth.selectedHospital.manager_dischargeList_commentsEnable &&
                <td>
                    <div className="d-inline-flex align-items-center">
                        {renderManagerDischargeListComments()}
                    </div>
                </td>
            }
            <AdmissionList_Item_ManagerCustomUI admission={admission} position={5} location="LOCATION_TYPE_DISCHARGE_LIST"/>
            {showSurveyDevUI &&
                <td>{renderSurveyStatus()}</td>
            }
            <td>
                <div className="d-inline-flex align-items-center">
                    {showSurveyDevUI && !admission.survey_status &&
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary mr-2"
                            onClick={sendSurvey}
                            disabled={sendingSurvey}
                        >
                            {sendingSurvey ? 'Sending...' : 'DEV - Send Survey'}
                        </button>
                    }
                    <AdmissionList_Item_MoreDrop admission={admission} location="LOCATION_TYPE_DISCHARGE_LIST"/>
                </div>
            </td>
        </tr>
    )
}


const areEqual = (prevProps, nextProps) => {
    // console.log('[Are Equal?]', JSON.stringify(prevProps) === JSON.stringify(nextProps));
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
}

export default DischargeList_Item;
export const DischargeList_Item_Memo = React.memo(DischargeList_Item, areEqual);